import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderShare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	"data-darkreader-inline-stroke": "",
	style: { "--darkreader-inline-stroke": "currentColor" },
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 22l5 -5" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 21.5v-4.5h-4.5" })
	]
});
const ForwardRef = forwardRef(SvgFolderShare);
export default ForwardRef;
